import * as React from 'react'
import { SettingsCategory } from '../util/SettingsConfigurations';
import { SettingsSidebarItem } from './SettingsSidebarItem';
import './SettingsSidebar.css'

export type ValueProps = {
  selectedCategory: SettingsCategory
  categories: SettingsCategory[]
}

export type EventProps = {
  onClick: (category: SettingsCategory) => void
}

export type Props = ValueProps & EventProps

const mapCategoryToItem = (props: Props) => (category: SettingsCategory, index: number) => {
  const {onClick, selectedCategory} = props
  const itemProps = {onClick, selectedCategory, category: category}
  
  return <SettingsSidebarItem key={index} {...itemProps} />
};

export const SettingsSidebar = (props: Props) => (
  <div className="settings-sidebar" data-test-id="settings-sidebar">
    <div>
      {props.categories.map(mapCategoryToItem(props))}
    </div>
  </div>
)